export default "__VITE_ASSET__B7y6gVYD__"